var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0043 4.95923H16.097C14.2561 4.95923 12.7637 6.4516 12.7637 8.29256V30.3384",
    stroke: "#E59E6D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9956 75.0407H63.9029C65.7439 75.0407 67.2363 73.5484 67.2363 71.7074V49.6614",
    stroke: "#E59E6D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09827 21.6667L12.7676 30.3361L21.4369 21.6667",
    stroke: "#E59E6D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9017 58.3339L67.2323 49.6646L58.563 58.3339",
    stroke: "#E59E6D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3492 61.8203C23.0461 61.8203 26.8537 58.0126 26.8537 53.3156C26.8537 48.6186 23.0461 44.8113 18.3492 44.8113C13.6522 44.8113 9.8446 48.6186 9.8446 53.3156C9.8446 58.0126 13.6522 61.8203 18.3492 61.8203Z",
    stroke: "#E59E6D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6052 75.0371C30.7431 68.9361 24.9762 64.3621 18.3517 64.3621C11.7272 64.3621 5.96033 68.9361 4.09827 75.0371",
    stroke: "#E59E6D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6434 21.9701C66.3404 21.9701 70.148 18.1625 70.148 13.4655C70.148 8.76857 66.3404 4.96094 61.6434 4.96094C56.9464 4.96094 53.139 8.76857 53.139 13.4655C53.139 18.1625 56.9464 21.9701 61.6434 21.9701Z",
    stroke: "#E59E6D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8994 35.1867C74.0374 29.0858 68.2707 24.5117 61.646 24.5117C55.0217 24.5117 49.2547 29.0858 47.3927 35.1867",
    stroke: "#E59E6D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.e8a7cd169b8288077546b849a7339c8d.svg";
export { ForwardRef as ReactComponent };